import script from "./ProjectHeaderLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectHeaderLogo.vue?vue&type=script&setup=true&lang=js"

import "./ProjectHeaderLogo.vue?vue&type=style&index=0&id=ecf1b9b4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecf1b9b4"]])

export default __exports__